<div class="remarks-trigger-wrapper">
    <ng-content></ng-content>
    <div class="remarks-trigger-button d-flex align-items-center text-center" (click)="DidTapTrigger()">
        <i class="pi pi-external-link text-muted"></i>
    </div>
</div>
